import React from 'react';
import { Pill } from '@99designs/frontend-components/components/Pill';

export interface UnreadCounterProps {
    subscribeToMore?: () => () => void;
    unreadCount?: number;
}

interface UnreadCounterState {
    unsubscribe: (() => void) | null;
}

// Expects the parent's parent container to have `position: absolute` style implemented for its own `position: relative`
export class UnreadCounter extends React.Component<UnreadCounterProps, UnreadCounterState> {
    static defaultProps: Partial<UnreadCounterProps> = { unreadCount: 0 };

    state: UnreadCounterState = {
        unsubscribe: null,
    };

    componentDidMount() {
        if (this.props.subscribeToMore) {
            const unsubscribe = this.props.subscribeToMore();
            this.setState({
                unsubscribe,
            });
        }
    }

    componentWillUnmount() {
        const { unsubscribe } = this.state;
        if (unsubscribe) {
            unsubscribe();
        }
    }

    render() {
        const { unreadCount } = this.props;
        if (!unreadCount || unreadCount === 0) {
            return null;
        }

        return (
            <span className="unread-counter">
                <Pill variations={['notification', 'tiny']}>
                    {unreadCount > 99 ? '99+' : unreadCount}
                </Pill>
            </span>
        );
    }
}
export default UnreadCounter;
